import React from 'react';

const STATUS_CONFIG = {
  // Lead-Status
  neu: { label: 'Neu', color: 'bg-blue-100 text-blue-800' },
  qualifiziert: { label: 'Qualifiziert', color: 'bg-purple-100 text-purple-800' },
  angebot_erstellt: { label: 'Angebot erstellt', color: 'bg-indigo-100 text-indigo-800' },
  angebot_gesendet: { label: 'Angebot gesendet', color: 'bg-cyan-100 text-cyan-800' },
  angebot_geoeffnet: { label: 'Angebot geoeffnet', color: 'bg-amber-100 text-amber-800' },
  in_verhandlung: { label: 'In Verhandlung', color: 'bg-orange-100 text-orange-800' },
  angenommen: { label: 'Angenommen', color: 'bg-green-100 text-green-800' },
  vertrag: { label: 'Vertrag', color: 'bg-emerald-100 text-emerald-800' },
  verloren: { label: 'Verloren', color: 'bg-red-100 text-red-800' },

  // Angebots-Status
  entwurf: { label: 'Entwurf', color: 'bg-gray-100 text-gray-800' },
  gesendet: { label: 'Gesendet', color: 'bg-blue-100 text-blue-800' },
  geoeffnet: { label: 'Geoeffnet', color: 'bg-amber-100 text-amber-800' },
  abgelaufen: { label: 'Abgelaufen', color: 'bg-gray-100 text-gray-600' },
  abgelehnt: { label: 'Abgelehnt', color: 'bg-red-100 text-red-800' },

  // Vollmacht-Status
  ausstehend: { label: 'Ausstehend', color: 'bg-yellow-100 text-yellow-800' },
  unterschrieben: { label: 'Unterschrieben', color: 'bg-green-100 text-green-800' },
  eingegangen: { label: 'Eingegangen', color: 'bg-emerald-100 text-emerald-800' },

  // Prioritaet
  niedrig: { label: 'Niedrig', color: 'bg-gray-100 text-gray-600' },
  normal: { label: 'Normal', color: 'bg-blue-100 text-blue-700' },
  hoch: { label: 'Hoch', color: 'bg-orange-100 text-orange-800' },
  dringend: { label: 'Dringend', color: 'bg-red-100 text-red-800' },
};

const StatusBadge = ({ status, className = '' }) => {
  const config = STATUS_CONFIG[status] || { label: status, color: 'bg-gray-100 text-gray-700' };

  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${config.color} ${className}`}>
      {config.label}
    </span>
  );
};

export default StatusBadge;
